import * as React from 'react';
import { CurrencyInput } from '../../../../components/form-elements/CurrencyInput';
import { CurrencyType } from '../../../../models/utilities/type-models';

// #region Component Props

interface IProps {
    // Events
    onFreightChange     : any;
    onTaxChange         : any;
    // Data
    subtotal            : number;
    freight             : number;
    tax                 : number;
    total               : number;
    isDealerTaxExempt   : boolean;
    currencyCode        : CurrencyType;
}

// #endregion

export class CreditLineItemSummary extends React.Component<IProps> {

    private subtotal : any;
    private freight : any;
    private tax : any;
    private total: any;

    public render() {
        const { 
            subtotal, freight, tax, 
            total, isDealerTaxExempt, 
            currencyCode, onFreightChange, 
            onTaxChange 
        } = this.props;

        return <div className="row justify-content-end">
            <div className="col-auto">
                <CurrencyInput
                    label="Subtotal"
                    id="subtotal"
                    className="side-by-side"
                    currencyType={ currencyCode }
                    disable={true}
                    showSymbol={true}
                    value={ subtotal } 
                    ref={(instance) => { this.subtotal = instance; }}
                    onChange={ () => { return; }} />
                <CurrencyInput
                    label="Freight"
                    id="freight"
                    className="side-by-side"
                    currencyType={ currencyCode }
                    showSymbol={true}
                    value={ freight } 
                    ref={(instance) => { this.freight = instance; }}
                    onChange={ onFreightChange} />
                <CurrencyInput
                    label="Tax"
                    id="tax"
                    className="side-by-side"
                    currencyType={ currencyCode }
                    showSymbol={true}
                    value={ tax } 
                    disable={ isDealerTaxExempt }
                    ref={(instance) => { this.tax = instance; }}
                    onChange={ onTaxChange} />
                <CurrencyInput
                    label="Total"
                    id="total"
                    className="side-by-side"
                    currencyType={ currencyCode }
                    disable={true}
                    showSymbol={true}
                    value={ total } 
                    ref={(instance) => { this.total = instance; }}
                    onChange={ () => { return; }} />
            </div>
        </div>;  
    }

    public reset() {
        this.subtotal.reset();
        this.total.reset();
        this.freight.reset();
        this.tax.reset();
    }
}
